export default "__VITE_ASSET__Bi7Bd9_3__"